import * as authConstants from "../constants/authConstants";
import * as HBConstants from "../constants/HBConstants";



const redirectMiddleware = () => (next) => (action) => {
  const { type, history, data } = action;

  switch (type) {
    case authConstants.LOGIN_SUCCESS:
      history("/")
      break;
/*     case authConstants.LOGOUT_SUCCESS:
      history("/login")
      break; */
    case authConstants.REGISTER_SUCCESS:
      history("/login");
      break;
    case HBConstants.HB_GET_URL_SUCCEEDED:
      window.open(data.login_url, "_blank");
      break;
    default:
      break;
  }
  return next(action);
};
export default redirectMiddleware;